import { CsatModal } from "@grupoboticario/conecta-core-react-components";
import AuthContext from "mfeAuth/AuthContext";
import ErrorBoundary from "../../components/ErrorBoundary";
import Loading from "../../components/Loading";
import React, { Suspense, useContext } from "react";

const Home = React.lazy(() => import("mfeHomePage/Home"));

export function HomePage() {
  const authContext = useContext<{ claim: { email: string } }>(AuthContext);
  return (
    <ErrorBoundary errorMessage="Erro ao carregar a home">
      <Suspense fallback={<Loading />}>
        {authContext?.claim?.email && (
          <CsatModal
            featureOrModuleName="Conecta"
            owner="Conecta-Core"
            personId={authContext.claim.email}
            apiUrl={process.env.REACT_APP_CSAT_SERVICE_URL ?? ""}
            isEnabled={
              process.env.REACT_APP_IS_CSAT_AVAILABLE
                ? `${process.env.REACT_APP_IS_CSAT_AVAILABLE}` === "true"
                : false
            }
          />
        )}
        <Home />
      </Suspense>
    </ErrorBoundary>
  );
}
